import {fromAPIData} from "../sensor";
import cookie from 'vue-cookie'

export default {
    login(state, user) {
        state.user = user;
    },
    restore(state, user) {
        state.user = user;
    },
    logout(state) {
        state.user = {};
        state.contacts = [];
        state.sensors = [];
    },
    failedLogin(state) {
        state.loginAttempts++;
    },
    userinfo(state, data) {
        state.user.info.adr1 = data.adr1;
        state.user.info.adr2 = data.adr2;
        state.user.info.adr3 = data.adr3;
        state.user.info.postcode = data.postcode;
        state.user.info.city = data.city;
        state.user.info.country = data.country;
        state.user.info.phone = data.phone;
        state.user.info.vat_number = data.vat_number;
        state.user.info.email_invoice = data.email_invoice;
    },
    contextuserinfo(state, data) {
        if(state.context === null)
            return;

        state.context.info.adr1 = data.adr1;
        state.context.info.adr2 = data.adr2;
        state.context.info.adr3 = data.adr3;
        state.context.info.postcode = data.postcode;
        state.context.info.city = data.city;
        state.context.info.country = data.country;
        state.context.info.phone = data.phone;
        state.context.info.vat_number = data.vat_number;
        state.context.info.email_invoice = data.email_invoice;
    },
    setSensors(state, sensors) {
        if (state.sensors.length > 0)
            state.sensors = [];

        sensors.forEach(function (itemData) {
            state.sensors.push(fromAPIData(itemData))
        })

        // Sort them with the ones in alarm being first
        state.sensors.sort(function (a, b) {

            if (a.alarm)
                return -1;
            else if (b.alarm)
                return 1;

            return a.label.localeCompare(b.label);
        })
    },
    sensorUpdated(state, sensor){

        // We only care about the name
        state.sensors.forEach(s => {
            if(s.serial === sensor.serial) {
                s.label = sensor.label;

                if(sensor.activated !== undefined)
                    s.activated = sensor.activated;
            }
        })
    },
    sensorRemoved(state, sensor){
        state.sensors = state.sensors.filter(s => s.serial !== sensor.serial);
    },
    setContext(state, user) {
        state.context = user;
        state.contextPath.push(user);
        cookie.set('context', JSON.stringify(user));
    },
    sliceContextPath(state, index) {
        state.contextPath = state.contextPath.slice(0, index);
        state.context = state.contextPath[index - 1];
        cookie.set('context', JSON.stringify(state.context));
    },
    clearContext(state) {
        state.context = null;
        state.contextPath = [];
        cookie.delete('context');
    },
    setContacts(state, data) {
        state.contacts = data;
    },
    updateContact(state, contact) {
        let index = state.contacts.findIndex(c => c.id === contact.id)
        if (index !== -1)
            state.contacts.splice(index, 1, contact)
    },
    removeContact(state, id){
        let index = state.contacts.findIndex(c => c.id === id)
        if (index !== -1)
            state.contacts.splice(index, 1)
    },
    setAlertingContacts(state, data) {
        state.alerting_contacts = data;
    },
    updateAlertingContact(state, contact) {
        let index = state.alerting_contacts.findIndex(c => c.id === contact.id)
        if (index !== -1)
            state.alerting_contacts.splice(index, 1, contact)
    },
    removeAlertingContact(state, id){
        let index = state.alerting_contacts.findIndex(c => c.id === id)
        if (index !== -1)
            state.alerting_contacts.splice(index, 1)
    },
    setLanguage(state, language){
        state.language = language;
        cookie.set("lang", language);
    },
    setFirmwareHistory(state, list){
        state.firmware_versions = list
    },
    addFirmwareHistory(state, entry){
        state.firmware_versions.push(entry)
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js